import React from "react";

const Footer = () => {
    return (
        <footer className="jewellery-footer text-center">
            <div className="container py-4">
                {/* Logo */}
                <h3 className="fw-bold footer-brand"> Trinket of Treasures 🧚🏻‍♀️</h3>
                {/* <p className="mb-3 slogan">
                    Unveiling timeless beauty, crafted just for you.
                </p> */}

                {/* Social Icons */}
                <div className="social-icons mb-3">
                    <a
                        href="https://www.instagram.com/trinket.of.treasure?igsh=MWUwMjAxcXcxY3pjZA=="
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    >
                        <i className="fab fa-instagram"></i>
                    </a>
                </div>

                <p className="copyright mb-0">
                    © 2025 Trinket of Treasure | Designed with 💖
                </p>
            </div>
        </footer>
    );
};

export default Footer;
